<script lang="ts" setup>
import TaxPlanIndex from "@/04-Widgets/TaxPlanList/ui/TaxPlanIndex.vue";
</script>

<template>
  <TaxPlanIndex />
</template>

<style scoped lang="sass"></style>
